import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./city.scss";

const City = () => {
  const [city, setCity] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/city`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setCity(data), setLoading(false);
      });
  }, []);
  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  return (
    <div className="city">
      <div className="container text-center cityposition">
        <h2 className="text-white citytext mb-4">Choose Your city</h2>
        {showloading()}
        {city.map((data) => {
          return (
            <Link key={data._id} to={`/home/${data._id}`}>
              <button
                className="btn mr-3"
                style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
              >
                {data.name}
              </button>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default City;
